module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword#toc_marker-3-1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgments#toc_marker-4-1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#toc_marker-5-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PART1"
    }
  }, [_vm._v("PART ONE: God the Father")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_vm._v("1 Community Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Creative Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Work Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Contemplative-Rest Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Prayer of Confession")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Blessing Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Worship Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PART2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: God the Son")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Daily Reflection Prayer—The Examen")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Lord’s Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Servant Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Simplicity Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Prayer in Play")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Scripture Prayer—"), _c('i', [_vm._v("Lectio Divina")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Relinquishment Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Forgiveness Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Sacrament Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PART3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: God the Holy Spirit")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Prayer Language—Tongues")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Conversational Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Breath Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Healing Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Meditative Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Discernment Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Watch Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Rejoice Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/closing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/relatedtitles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0